<template>
<transition name="slide-fade">
    <div class="dialog-view invite_apply" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-invite-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="title"></div>
                    <div class="share-text msg-view">
                        <p v-if="!team_switch">请确认是否接受来自{{ player_data }}的绑定邀请。</p>
                        <p v-else>{{ error_text }}</p>
                    </div>
                    <p class="warn">
                        <em class="i-warn"></em><span>每位玩家只能接受1人的绑定且无法解绑，请谨慎选择。</span>                       
                    </p>
                </div>

                <div class="u-ctrl" v-if="!team_switch">
                    <button class="u-btn cancel"  @click="destroyElement"></button> 
                    <button class="u-btn apply"  @click="apply"></button>                    
                </div>
            </div>         
        </div>
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试', 
            error : false,           
        }
    },
    created (){
        this.render();
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.invite_info,{
                params : {
                    inviteCode : this.code,
                }
            })
            .then(res => {
                this.player_data = res.data;
            },rej => {
                //this.destroyElement();
                this.$toast('请稍后再试')
                this.team_switch = true;
                this.error_text = rej.message;
                this.$toast(rej.message);
                this.$store.commit("$_setCode", '');
                localStorage.setItem('code', '');                        
            });
        },
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            this.$axios.post(ajax_url_map.apply_invite,{
                inviteCode : this.code,
            })
            .then(
                res => {
                    this.destroyElement();
                    this.$toast('绑定成功~')
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                },
                rej => {
                    this.destroyElement();
                    this.$toast(rej.message)
                    
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                    
                }
            );
        },                
    },
}
</script>

<style lang="scss" scoped>
    @mixin boxStyle ( $screenWidth ){
        .dialog-view{
            z-index: 100;
        }
    
        .m-invite-modal{
            width: 620px;
            height: 290px;
            background-image: url(~@/assets/images/modal/bg-modal-apply.png);        
        }
    
        .title{
            width: 524px;
            height: 51px;
            margin: 0 auto 30px;
            background-image: url(~@/assets/images/modal/title-invite-apply.png); 
        }
    
        .msg-view{
            text-align: center;
            margin: 20px auto;
            padding: 0 50px;
            font-size: 22px;
    
            color: #4b4846;
        }

        .warn{
            text-align: center;
            font-size: 20px;
            color: #c2393f;
        }

        .i-warn{
            display: inline-block;
            width: 17px;
            height: 18px;
            margin-right: 15px;
            background-image: url(~@/assets/images/modal/icon-warn.png);
            vertical-align: middle; 
        }          

        .u-ctrl{
            display: flex;
            justify-content: space-between;
            position: absolute;
            position: absolute;
            left: 50%;
            bottom: 25px;
            transform: translateX(-50%);

            .u-btn{
                margin: 0 20px;
            }

            .u-btn.cancel{

                width: 207px;
                height: 55px;
                background-image: url(~@/assets/images/modal/btn-cancel.png);                  

                @if ( $screenWidth == 1600) {
                    &:hover{
                        background-image: url(~@/assets/images/modal/btn-cancel_hover.png);
                    }
                }
            } 
            
            
            .u-btn.apply{
                
                width: 207px;
                height: 55px;
                background-image: url(~@/assets/images/modal/btn-ok.png);                  

                @if ( $screenWidth == 1600) {
                    &:hover{
                        background-image: url(~@/assets/images/modal/btn-ok_hover.png);
                    }
                }

            }             
        }
    
   
    
    }
    
    
    @media screen and (min-width: 1000px){
        @include boxStyle( 1600 );
    }
    @media screen and (min-width: 375px) and (max-width: 999px){
        @include boxStyle( 1000 );
    }   
</style>


// WEBPACK FOOTER //
// src/components/inviteApply/inviteApply.vue